import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { VesselService, VesselModel, VesselMapModel, PagerService, Oper, AlertService, TableHeader, CommonService } from '../../services/index'
import { Util } from '../../utils/util'
import _ from 'lodash';
import similarity from 'string-similarity';

declare var $:any;

@Component({
  selector: 'vessel-map-list',
  templateUrl: 'vessel-map-list.html' 
})
export class VesselMapList implements OnInit{
    //공통
    @Output() onFindVessel: EventEmitter<any> = new EventEmitter();
    @Output() onClearClickedVessel: EventEmitter<any> = new EventEmitter();

    @Input() vesselList:Array<VesselModel> = new Array<VesselModel>();

    _vesselId:number;
    @Input() set vesselId(vesselId:number){
        this._vesselId = vesselId;
        if(vesselId == null || vesselId == undefined) return;
        this.getVesselMapListByVesselId(vesselId, true);
    }
    get vesselId(){
        return this._vesselId;
    }

    dateFomatter: Function = Util.dateFomatter;    
    operList:Array<Oper> = new Array();
    tabIndex:number = 0;

    //탭1
    clickedVesselMapId1:number;

    allVesselMapList1: Array<VesselMapModel> = new Array();
    vesselMapList1: Array<VesselMapModel> = new Array();
    pagedItems1: Array<VesselMapModel> = new Array();
    
    pager1: any = {};
    
    allMappingMapChecked = false;
    condition1:ConditionSearch1 = new ConditionSearch1();
    tempVesselMapList: Array<VesselMapModel> = new Array();
    isOpenVessleMapUpdate = false;
    updTargetVesselMapList:Array<VesselMapModel> = new Array();

    headerList1:Array<TableHeader> = null;
    

    //탭2
    clickedVesselMapId2:number;

    openVesselMapId:number;

    allVesselMapList2: Array<VesselMapModel> = new Array();
    vesselMapList2: Array<VesselMapModel> = new Array();
    
    pager2: any = {};
    pagedItems2: Array<VesselMapModel> = new Array();   

    isShowVesselMapDetail:boolean = false;

    condition2:ConditionSearch2 = new ConditionSearch2();

    headerList2:Array<TableHeader> = null;

    constructor(
        private vesselService:VesselService,
        private pagerService: PagerService,
        private alertService:AlertService,
        private commonService:CommonService
    ) {}

    ngOnInit(){
        this.makeOperList();
        this.getVesselMapList(true);

        this.makeHeaderTab1();
        this.makeHeaderTab2();
        
        this.commonService.headerSortedEmit.subscribe(data =>{
            if(data.type == 1){
                this.allVesselMapList1 = data.data;
                this.searchVesselMap1(null, null);
            }else{
                this.allVesselMapList2 = data.data;
                this.searchVesselMap2(false);
            }
          });
        this.commonService.clearHeaderEmit.subscribe(data =>{
            if(data.type == 1){
                this.headerList1 = data.headerList;
            }else{
                this.headerList2 = data.headerList;
            }
        });

    }

    makeHeaderTab1(){
        this.headerList1 = new Array<TableHeader>();
        this.headerList1.push(new TableHeader(0, 'isChecked', '선택', false));
        this.headerList1.push(new TableHeader(1, 'vesselMapId', 'No.', true));
        this.headerList1.push(new TableHeader(2, 'operCd', '수집 선사', true));
        this.headerList1.push(new TableHeader(3, 'operVslNm', '수집 선박 이름', true));
        this.headerList1.push(new TableHeader(4, 'operTpNm', '수집 타입 코드', true));
        this.headerList1.push(new TableHeader(5, 'vesselMap.vessel.vslNm', '매핑 선박 이름', true));
        this.headerList1.push(new TableHeader(6, 'vesselMapStatusNm', '상태코드', true));
        this.headerList1.push(new TableHeader(7, 'reqSystemNm', '스크랩퍼 타입', true));
        this.headerList1.push(new TableHeader(8, 'remark', '기타', true));
        this.headerList1.push(new TableHeader(9, 'reqDtm', '등록일시', true));
        this.headerList1.push(new TableHeader(10, 'modifyUser.lastNm', '수정자', true));
        this.headerList1.push(new TableHeader(11, 'modifyDate', '수정일시', true));
    }

    makeHeaderTab2(){
        this.headerList2 = new Array<TableHeader>();
        this.headerList2.push(new TableHeader(1, 'vesselMapId', 'No.', true));
        this.headerList2.push(new TableHeader(2, 'operCd', '수집 선사', true));
        this.headerList2.push(new TableHeader(3, 'operVslNm', '수집 선박 이름', true));
        this.headerList2.push(new TableHeader(4, 'operTpNm', '수집 타입 코드', true));
        this.headerList2.push(new TableHeader(5, 'vesselMap.vessel.vslNm', '매핑 선박 이름', true));
        this.headerList2.push(new TableHeader(6, 'vesselMapStatusNm', '상태코드', true));
        this.headerList2.push(new TableHeader(7, 'reqSystemNm', '스크랩퍼 타입', true));
        this.headerList2.push(new TableHeader(8, 'remark', '기타', true));
        this.headerList2.push(new TableHeader(9, 'reqDtm', '등록일시', true));
        this.headerList2.push(new TableHeader(10, 'modifyUser.lastNm', '수정자', true));
        this.headerList2.push(new TableHeader(11, 'modifyDate', '수정일시', true));
    }

    makeOperList(){
        this.vesselService.oceanLineListEe.subscribe( data => {
            for(let ocean of this.vesselService.oceanLineList){
                let oper = new Oper();
                oper.operCd = ocean.lineCd;
                oper.operNm = ocean.lineNm;
                oper.operTpCd = 0;
                oper.operTpNm = 'SHIP_OPERATOR';
                this.operList.push(oper);
            }
        });
        this.vesselService.terminalListEe.subscribe( data => {
            for(let terminal of this.vesselService.terminalList){
                let oper = new Oper();
                oper.operCd = terminal.terminalCd;
                oper.operNm = terminal.terminalNm;
                oper.operTpCd = 1;
                oper.operTpNm = 'TERMINAL';
                this.operList.push(oper);
            }
        });
        this.vesselService.getOceanLineList();
        this.vesselService.getTerminalList();
    }

    getVesselMapList(isInit:boolean){
        if(this.condition1.status == 99){
            this.vesselService.getVesselMapList().subscribe(
                res =>{
                    if(res != null && res.result){
                        this.vesselMapList1 = res.data;
                        this.allVesselMapList1 = res.data;
                        this.searchVesselMap1(null, null);
                        if(!isInit) {
                            if(this.vesselId != null && this.vesselId != undefined){
                                this.getVesselMapListByVesselId(this.vesselId, false);
                            }
                        }
                    }
                }
            );
        }else{
            this.vesselService.getVesselMapListByStatus(Number(this.condition1.status)).subscribe(
                res =>{
                    if(res != null && res.result){
                        this.vesselMapList1 = res.data;
                        this.allVesselMapList1 = res.data;
                        this.searchVesselMap1(null, null);
                        if(!isInit) {
                            if(this.vesselId != null && this.vesselId != undefined){
                                this.getVesselMapListByVesselId(this.vesselId, false);
                            }
                        }
                    }
                }
            );
        }
        
    }

    getVesselMapListByVesselId(vesselId:number, isInit:boolean){
        this.vesselService.getVesselMapListByVesselId(vesselId).subscribe(
            res =>{
                if(res != null && res.result){
                    this.vesselMapList2 = res.data;
                    this.allVesselMapList2 = res.data;
                    if(isInit) this.setPage2(1);
                    else{
                        this.searchVesselMap2(false);
                    }
                }
            }
        );
    }

    setPage1(page:number){

        this.pager1 = this.pagerService.getPager(this.vesselMapList1.length, page, Number(this.condition1.pageSize));

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager1.totalPages) {
          this.pager1 = this.pagerService.getPager(this.vesselMapList1.length, this.pager1.totalPages);
        }
    
        this.pagedItems1 = this.vesselMapList1.slice(this.pager1.startIndex, this.pager1.endIndex + 1);

        if (_.isEmpty(this.pagedItems1)) {
            this.allMappingMapChecked = false;
            return;
        }
        let checkedCnt = 0;
        for(let k = 0 ; k < this.pagedItems1.length; k++) {
            if(this.pagedItems1[k].isChecked) checkedCnt++;
        }

        if(checkedCnt == this.pagedItems1.length) this.allMappingMapChecked = true;
        else this.allMappingMapChecked = false;
    }

    setPage2(page:number){

        this.pager2 = this.pagerService.getPager(this.vesselMapList2.length, page, 10);

        // if (page < 1) {
        //   return;
        // }
    
        if(page > this.pager2.totalPages) {
          this.pager2 = this.pagerService.getPager(this.vesselMapList2.length, this.pager2.totalPages);
        }
    
        this.pagedItems2 = this.vesselMapList2.slice(this.pager2.startIndex, this.pager2.endIndex + 1);
    }

    searchVesselMap2(event) {

        var filterValue = this.condition2.text;
        
        if(event && event.keyCode != 13) return;
              
        // if(this.allVesselMapList2.length < 1) return;

        this.vesselMapList2 = _.filter(this.allVesselMapList2, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });
        
        if(event) this.setPage2(1);
        else this.setPage2(this.pager2.currentPage == 0 ? 1 : this.pager2.currentPage);
    }

    searchVesselMap1(type:string, event){
        if(type == null){
            
        }else if(type.indexOf('operType') > -1){
            this.condition1.operType = event;
        }else if(type.indexOf('initial') > -1){
            this.condition1.initial = event;
        }else if(type.indexOf('status') > -1){
            this.condition1.status = event;
        }else if(type.indexOf('search') > -1){
            if(event.keyCode != 13) return;
        }

        var filterValue = this.condition1.text;

        if(this.allVesselMapList1.length < 1) {
            this.pagedItems1 = new Array();
            this.pager1 = new Array();
            return;
        }

        this.vesselMapList1 = _.filter(this.allVesselMapList1, (item:VesselMapModel) => {
            if(this.condition1.operType == 'ALL') return true;
            else if(!item.operCd) return false;
            else if(item.operCd.indexOf(this.condition1.operType) > -1) return true;
            else return false;
        });

        this.vesselMapList1 = _.filter(this.vesselMapList1, (item:VesselMapModel) => {
            let firstChar = item.operVslNm.trim().charAt(0).toLocaleLowerCase();
            if(this.condition1.initial == 'ALL') return true;
            else if(this.condition1.initial != '기타' && !item.operTpNm) return false;
            else if(this.condition1.initial != '기타' && firstChar.indexOf(this.condition1.initial.toLocaleLowerCase()) > -1) return true;
            else if(this.condition1.initial == '기타'){
                var strReg = /^[A-Za-z]+$/; 
                if(!strReg.test(firstChar)){
                    return true;
                }
            }
            else return false;
        });

        // this.vesselMapList1 = _.filter(this.vesselMapList1, (item:VesselMapModel) => {
        //     if(this.condition1.status == 'ALL' && item.vesselMapStatusNm.indexOf('SKIP') < 0) {
        //         return true;
        //     }else if(item.vesselMapStatusNm.indexOf(this.condition1.status) > -1){
        //         return true;
        //     }
        //     else return false;
        // });

        this.vesselMapList1 = _.filter(this.vesselMapList1, item => {
                if (!filterValue) return true;

                let valuesStr = Util.getString(item);
                const filter = filterValue.toLocaleLowerCase().replace(/\s/gi, "");
                return valuesStr.indexOf(filter) >= 0;
        });

        // this.vesselMapList1 = _.orderBy(this.vesselMapList1, '[operVslNm]', '[desc]');
        

        if(type != null){
            this.setPage1(1);
        }else{
            this.setPage1(this.pager1.currentPage);
        }
    }

    openVesselMapDetail(vesselMapId:number){
        this.openVesselMapId = vesselMapId;
        this.isShowVesselMapDetail = true;
    }  

    vesselMapAdd(){
        this.openVesselMapId = null;
        this.isShowVesselMapDetail = true;
    }

    mappingMapRemove(vesselMap:VesselMapModel){
        this.tempVesselMapList = _.remove(this.tempVesselMapList, (map:VesselMapModel) =>{
            if(vesselMap.vesselMapId == map.vesselMapId) return false;
        });
    }

    vesselMapChecked(index, fieldNm, checked){
        if(this.pagedItems1[index]) this.pagedItems1[index][fieldNm] = checked;
    }

    checkAll(isChecked) {
        this.allMappingMapChecked = true;
        if (_.isEmpty(this.pagedItems1)) return;
        for(let k = 0 ; k < this.pagedItems1.length; k++) {
            this.pagedItems1[k].isChecked = isChecked;
        }
    }

    doMapping(){
        
        let that = this;

        $.sweetModal.confirm('매핑을 진행하시겠습니까??', function() {
            if(that.tabIndex != 0){
                $.sweetModal({
                    content: "Vessel Mapping 탭에서만 이용 가능합니다.",
                    icon: $.sweetModal.ICON_WARNING,
                });
                return;
            }
    
            if(!that.vesselId){
                $.sweetModal({
                    content: "매핑할 Vessel의 값이 존재하지 않습니다. Vessel을 선택해주세요.",
                    icon: $.sweetModal.ICON_WARNING,
                });
                return;
            } 
    
            that.tempVesselMapList = _.map(
                    _.filter(that.allVesselMapList1, 
                        (vesselMap:VesselMapModel) => {
                        if(vesselMap.isChecked) return true;
                    }),
                    (vesselMap:VesselMapModel) =>{
                        vesselMap.vessel = new VesselModel();
                        vesselMap.vessel.vslId = that.vesselId;
                        vesselMap.vesselMapStatusCd = 1;
                        return vesselMap;
                    }
                    
            );

            if(that.tempVesselMapList.length < 1){
                $.sweetModal({
                    content: "매핑할 Vessel Map 값이 존재하지 않습니다. Vessel Map을 선택해주세요.",
                    icon: $.sweetModal.ICON_WARNING,
                });
                return;
            }

            that.vesselService.patchVesselMap(that.tempVesselMapList).subscribe( res => {
                if(res.result){
                    that.alertService.success('매핑이 완료 되었습니다.');
                    that.refreshVesselMap(1);
                }
            });


        }, function() {
            
        });
    }

    openVessleMapUpdate(){
        this.updTargetVesselMapList = _.cloneDeep(
            _.filter(this.allVesselMapList1, 
                (vesselMap:VesselMapModel) => {
                if(vesselMap.isChecked) return true;
            })
        );

        this.isOpenVessleMapUpdate = true;
    }

    findVessel(operVslNm:string, vesselMapId:number){
        this.vesselId = null;
        this.clickedVesselMapId1 = vesselMapId;
        this.onFindVessel.emit({operVslNm:operVslNm, vesselMapId:vesselMapId});
    }

    refreshVesselMap(event){
        if(event == 1) {
            this.getVesselMapList(false);
            this.closeUpdateList();
        }
        else if(event == 2 && this.vesselId != null && this.vesselId != undefined) {
            this.getVesselMapListByVesselId(this.vesselId, false);
            this.closeDetail();
        }
    } 

    tabClick(index){
        this.tabIndex = index;
    }

    selectedChecked(event){
        this.condition1.checkedType = event;

        this.vesselMapList1 = _.filter(this.allVesselMapList1, (item:VesselMapModel) => {
            if(this.condition1.checkedType == 'ALL') return true;
            else if(this.condition1.checkedType == 'TRUE' && item.isChecked) return true;
            // else if(this.condition1.checkedType == 'FALSE' && !item.isChecked) return true;
            else return false;
        });

        this.setPage1(1);
    }

    closeDetail(){
        this.isShowVesselMapDetail = false;
        this.openVesselMapId = null;
    }

    getListByStatus(event){
        this.condition1.status = event;
        this.getVesselMapList(true);
    }

    selectedPageSize(event){
        this.condition1.pageSize = event;
        this.setPage1(1);
    }

    closeUpdateList(){
        this.isOpenVessleMapUpdate = false;
    }
}

class ConditionSearch1{
    text:string = "";
    operType:string = "ALL";
    initial:string = "ALL";
    status:number = 0;
    checkedType:string = "ALL";
    pageSize:number = 10;
}

class ConditionSearch2{
    text:string = "";
}


// WEBPACK FOOTER //
// ./src/app/containers/vessel/vessel-map-list.ts